import { render, staticRenderFns } from "./airport.vue?vue&type=template&id=0f6a2547&scoped=true&"
import script from "./airport.vue?vue&type=script&lang=js&"
export * from "./airport.vue?vue&type=script&lang=js&"
import style0 from "./airport.vue?vue&type=style&index=0&id=0f6a2547&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a2547",
  null
  
)

export default component.exports